import { adminGetWebshopOrders } from 'cloudFunctions'
import { useCallback, useEffect, useState } from 'react'

export const useWebshopOrders = id => {
  const [loading, setLoading] = useState(true)
  const [orders, setOrders] = useState([])

  const fetchOrders = useCallback(async () => {
    setLoading(true)
    const { data: orders } = await adminGetWebshopOrders({
      auctionId: id,
    })
    setOrders(orders)
    setLoading(false)
  }, [id])

  useEffect(() => {
    fetchOrders()
  }, [fetchOrders])

  return { orders, loading }
}
